import { MovingDateValues } from '@/src/types/MoveOut';

/**
 * Transforms the date contained in the MovingDateValues object into a string
 * containing the date in the format YYYY-MM-DD ready for use with KAPI.
 */
export const toDateString = (movingDate: MovingDateValues) => {
  const {
    date: { day, month, year },
  } = movingDate;

  return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
};

export function toDate(movingDateValues: MovingDateValues) {
  const {
    date: { day, month, year },
  } = movingDateValues;

  return new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
}

export const fromDate = (
  date: Date | undefined,
): MovingDateValues | undefined => {
  if (!date) {
    return undefined;
  }

  const day = date.getDate().toString();
  const month = (date.getMonth() + 1).toString();
  const year = date.getFullYear().toString();

  return { date: { day, month, year } };
};

/**
 * Checks if all required fields in MovingDateValues are filled
 */
export function isMovingDateComplete(
  movingDateValues: MovingDateValues,
): boolean {
  const {
    date: { day, month, year },
  } = movingDateValues;

  return Boolean(day && month && year);
}
